export function formatState(val){
    let stateName = undefined;
    switch (val) {
        case '01':
            stateName = '待付款';
            break;
        case '02':
            stateName = '已付款';
            break;
        case '03':
            stateName = '排单中';
            break;
        case '04':
            stateName = '生产中';
            break;
        case '05':
            stateName = '已发货';
            break;
        case '06':
            stateName = '已取消';
            break;
        case '07':
            stateName = '已删除';
            break;
        default:
            stateName = '未知';
            break;

    }
    return stateName;
}

/*格式化时间为: YYYY-MM-DD HH:mm:ss*/
export function formateDate(datetime) {
    if (datetime == null || datetime == undefined || datetime == 'undefined')
        return '';
    function addDateZero(num) {
        return (num < 10 ? '0' + num : num)
    }
    const d = new Date(datetime)
    const formatdatetime = d.getFullYear() + '-' + addDateZero(d.getMonth() + 1) + '-' + addDateZero(d.getDate()) + ' '

    // const formatdatetime = d.getFullYear() + '-' + addDateZero(d.getMonth() + 1) + '-' + addDateZero(d.getDate()) + ' ' + addDateZero(d.getHours()) + ':' + addDateZero(d.getMinutes()) + ':' + addDateZero(d.getSeconds())
    return formatdatetime
}

/* 我的订单--组装数据*/
export function formAssemble(data) {
    const params = {
        "pageNum": data.pageNum,
        "pageSize": data.pageSize,
        "prodTitle": data.prodTitle,
        "appNo": data.appNo,
    };
    // if (data.orderDate != null) {
    //     params.orderTime = formateDate(data.orderDate[0]);
    //     params.orderTimeEnd = formateDate(data.orderDate[1]);
    // }
    if (data.kssj != null) {
        params.orderTime = formateDate(data.kssj)+"00:00:00";
    }
    if (data.jssj != null) {
        params.orderTimeEnd = formateDate(data.jssj)+"23:59:59";
    }
    return params;
}

/* 再次购买--接口服务 */
export function Repurchase(order) {
    let details = order.details;
    let list = [];
    details.forEach(row =>{
        let vo = {
            "designId": row.designId, "pId":row.pId, "appId":row.appId,
            "proTitle":row.prodTitle, "price":row.price, "picUrl":row.picUrl,
            "properName":row.properName, "properVal":row.properVal, "proAmount":row.num,
            "selfType":order.selfType, "subtotal":row.total, "appSkuId":row.appSkuId
        }
        list.push(vo);
    });
    return list;
}
